<app-base-modal
  [title]="titleModal[articleDialogData.modalKey]"
>
  <div class="container">
    <div class="cards">
      @for (item of articles; track $index) {
        <div class="article-card">
          <div class="article-card-header">
            <div class="article-id">Артикул: </div>
            <a
              mat-raised-button
              target="_blank"
              [href]="item.link"
              [matTooltip]="item.link"
            >
              {{ item.article }}
            </a>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      tabindex="-1"
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
